import { Column, Entity, OneToMany } from '../entity/index';
import { IEntity } from '../interfaces/models';
import { ColumnType, LanguagePage, PageTitles } from '../interfaces/types';

export interface IFsaAssignment extends IEntity {
  id: string;
  coid: string;
  fsa: string;
  territoryId: number;
}

@Entity({
  name: PageTitles.fsaAssignment,
  language: LanguagePage.fsaAssignment,
})
export class FsaAssignment implements IFsaAssignment {
  id: string;
  coid: string;
  fsa: string;
  territoryId: number;

  constructor(
    fsaAssigment: IFsaAssignment = {
      id: '',
      coid: '',
      fsa: '',
      territoryId: null,
    }
  ) {
    const { id, coid, fsa, territoryId } = fsaAssigment;

    this.id = id;
    this.coid = coid;
    this.fsa = fsa;
    this.territoryId = territoryId;
  }

  static createFromDTO(record: IFsaAssignment): IFsaAssignment {
    return new FsaAssignment({
      ...record,
    });
  }
}
